export function setThemeColor(color: string) {
  const themeMetaEl = document.getElementById("meta-theme-color");

  if (themeMetaEl) themeMetaEl.setAttribute("content", color);
}
